module.exports = __webpack_public_path__ + "src/img/iframe.3c27a23b7e127873bf14ca646bdb34e5.png";